/**
 * @generated SignedSource<<e112a5e5f873ae424ea1858f05640edc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetWeatherCurrentPane_weatherOccasion$data = {
  readonly description: string;
  readonly temp: number;
  readonly " $fragmentType": "WidgetWeatherCurrentPane_weatherOccasion";
};
export type WidgetWeatherCurrentPane_weatherOccasion$key = {
  readonly " $data"?: WidgetWeatherCurrentPane_weatherOccasion$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetWeatherCurrentPane_weatherOccasion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetWeatherCurrentPane_weatherOccasion",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "temp",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    }
  ],
  "type": "WidgetWeatherOccasion",
  "abstractKey": null
};

(node as any).hash = "c2d13a4d1bf3484f9f2e76362fdeb8cf";

export default node;
